import React from 'react';

const DeviceTablet = ({ ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.16797 3.33333C4.16797 3.11232 4.25577 2.90036 4.41205 2.74408C4.56833 2.5878 4.78029 2.5 5.0013 2.5H15.0013C15.2223 2.5 15.4343 2.5878 15.5906 2.74408C15.7468 2.90036 15.8346 3.11232 15.8346 3.33333V16.6667C15.8346 16.8877 15.7468 17.0996 15.5906 17.2559C15.4343 17.4122 15.2223 17.5 15.0013 17.5H5.0013C4.78029 17.5 4.56833 17.4122 4.41205 17.2559C4.25577 17.0996 4.16797 16.8877 4.16797 16.6667V3.33333Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.16797 14.1667C9.16797 14.3877 9.25577 14.5996 9.41205 14.7559C9.56833 14.9122 9.78029 15 10.0013 15C10.2223 15 10.4343 14.9122 10.5906 14.7559C10.7468 14.5996 10.8346 14.3877 10.8346 14.1667C10.8346 13.9457 10.7468 13.7337 10.5906 13.5774C10.4343 13.4211 10.2223 13.3333 10.0013 13.3333C9.78029 13.3333 9.56833 13.4211 9.41205 13.5774C9.25577 13.7337 9.16797 13.9457 9.16797 14.1667Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
DeviceTablet.displayName = "Icons.DeviceTablet";

export { DeviceTablet };
//# sourceMappingURL=DeviceTablet.js.map
